import React from 'react';
import Grid from '../layout/grid';

export default props => {
	if (!props.limpar) {
		return (
			<Grid cols={props.cols} style={{ minWidth: 165, maxWidth: 165 }}>
				<div className='form-group' style={{ marginBottom: props.marginBottom }}>
					{props.label &&
					<label htmlFor={props.name}>{props.label}</label>}
					<input {...props.input}
						className='form-control'
						maskChar={' '}
						style={{ fontSize: props.fontSize }}
						placeholder={props.placeholder}
						readOnly={props.readOnly} type={'date'}
						value={(props.value || '').split('/').join('-').split('T')[0]}
						onChange={data => props.onChange(data.target.value || null)} />
				</div>
			</Grid>
		);
	} else {
		return (
			<Grid cols={props.cols} style={{ minWidth: 198, maxWidth: 198 }}>
				<div className='form-group' style={{ marginBottom: props.marginBottom }}>
					{props.label &&
					<label htmlFor={props.name}>{props.label}</label>}
					<div style={{ display: 'flex' }}>
						<input {...props.input}
							className='form-control'
							maskChar={' '}
							style={{
								fontSize: props.fontSize,
								flex: 1,
								marginRight: 0,
								minWidth: 145, 
								maxWidth: 145
							}}
							placeholder={props.placeholder}
							readOnly={props.readOnly} type={'date'}
							value={(props.value || '').split('/').join('-').split('T')[0]}
							onChange={data => props.onChange(data.target.value || null)} />
						{props.limpar &&
						<button 
							type='button'
							className={`btn btn-secondary`}
							title='Limpar data'
							onClick={() => props.onChange(null)}
							style={{
								width: 38,
								minWidth: 38,
								height: 38,
								padding: 0,
								marginLeft: 0
							}}>
							<i
								className={'fas fa-times'}
								style={{
									fontSize: props.small ? 12 : 14,
									color: props.type === 'light'
										? props.color || '#495057'
										: props.color || '#ffffff',
									lineHeight: 1
								}}
							/>
						</button>}
					</div>
				</div>
			</Grid>
		)
	}
}
